import Immutable from 'seamless-immutable';

import {
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
  SET_NOTIFICATION
} from '../Actions/Notification';

const initialState = {
  notificationType: null,
  show: false,
  message: '',
  autoHide: true,
  autoHideDelay: 3000
};

export default function notificationReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return Immutable.merge(state, {
        show: true
      });

    case HIDE_NOTIFICATION:
      return Immutable.merge(state, {
        show: false
      });

    case SET_NOTIFICATION:
      return Immutable.merge(state, {
        show: true,
        ...action
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/NotificationReducer.js